import { OpenApiAttributeFormValidatorFactory } from './Factory.js';
export default {
  type: 'composite',
  validator: (model, attr) => {
    const {
      validators
    } = model;
    let validate;
    if (!validators || validators.length === 0) {
      validate = () => true;
    } else {
      validate = (...args) => {
        for (let i = 0; i < validators?.length; i++) {
          const validator = OpenApiAttributeFormValidatorFactory.create(validators[i], attr);
          const res = validator.validate(...args);
          if (res !== true) {
            return res;
          }
        }
        return true;
      };
    }
    return {
      active: true,
      validate
    };
  }
};